import React, { Component } from "react";
import { Link } from "react-router";
import Logo from "../../assets/images/notifyi-logo-dark.png"
import LogoMb from "../../assets/images/notify-logo-mb.png"
import AdmissionApi from "../../Services/AdmissionApi";
import PropTypes from "prop-types";
import IconButton from 'material-ui/IconButton'
import { MenuIcon } from '@heroicons/react/outline'
import "./style.css";

const styles = {
  activeLink: {
    color: 'var(--primary-400-base)',
    borderBottom: '2px solid var(--primary-400-base)',
    fontWeight: '600'
  }
}
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      logo: "",
      isLogin: false
    };

    this.admissionsService = new AdmissionApi();
  }

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  logoutUser = () => {
    let type = localStorage.getItem("type");
    if (type == 1) {
      let _type = 0;
      localStorage.setItem("type", _type);
    }
    localStorage.setItem("isLogin", "0");
    this.context.router.push("/");
  }

  componentDidMount() {
    let check = localStorage.getItem("isLogin");
    if (check == 1) {
      this.setState({ isLogin: 1 })
    } else {
      this.setState({ isLogin: 0 })
    }
  }

  render() {

    let type = localStorage.getItem("isLogin");

    return (
      <header id="js-header" className={`u-header admn-header ${type === '1' && 'pt-0'}`}>
        <div className="u-header__section">
          {type === '1' && (
            <div className="g-bg-main">
              <div className="container mb-0 mb-lg-3">
                <ul className="list-inline d-flex justify-content-end align-items-center g-mb-0">
                  <li className="list-inline-item d-lg-none g-py-5">
                    <Link
                      id="mega-menu-label-1"
                      to="/dashboard"
                      className="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15  g-px-10 g-py-15"
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="list-inline-item d-none d-lg-inline-block g-py-5">
                    <Link
                      id="mega-menu-label-1"
                      to="/AdmissionAlerts"
                      className="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15  g-px-10 g-py-15"
                    >
                      Admission Alerts
                    </Link>
                  </li>
                  <li className="list-inline-item d-none d-lg-inline-block g-py-5">
                    <Link
                      id="mega-menu-label-1"
                      to="/scholarship"
                      className="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15  g-px-10 g-py-15"
                    >
                      Scholarships
                    </Link>
                  </li>
                  <li className="list-inline-item d-none d-lg-inline-block g-py-5">
                    <Link
                      id="mega-menu-label-1"
                      to="/careers"
                      className="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15  g-px-10 g-py-15"
                    >
                      Careers
                    </Link>
                  </li>
                  <li className="list-inline-item g-py-5">
                    <button
                      id="mega-menu-label-1"
                      onClick={this.logoutUser}
                      className="btn btn-link u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15  g-px-10 g-py-15"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          )}

          <div className="container">
            <nav className="navbar navbar-expand-lg g-px-0 g-py-5 g-py-0--lg hs-menu-initialized hs-menu-horizontalhs-mobile-state">
              <a href="/" className="navbar-brand g-max-width-170 g-max-width-200--lg">
                <img
                  className="d-none d-lg-block"
                  style={{ width: 100 }}
                  src={Logo}
                  alt="Logo"
                />
                <img
                  className="d-lg-none"
                  style={{ width: 140 }}
                  src={LogoMb}
                  alt="Logo"
                />
              </a>
              <IconButton className="navbar-toggler navbar-toggler-right" data-toggle="collapse" data-target="#navbarNav">
                <MenuIcon className='text-dark' />
              </IconButton>
              <div id="navbarNav" className="collapse navbar-collapse justify-content-end">
                <ul className="navbar-nav align-items-lg-center g-py-10 g-py-0--lg text-left">
                  <li className="nav-item hs-has-mega-menu">
                    <Link
                      id="mega-menu-label-1"
                      to="/"
                      activeStyle={styles.activeLink}
                      className="nav-link admn-nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl"
                    >
                      Home
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      href="#"
                      className="ml-2 nav-link admn-nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl dropbtn"
                    >
                      About
                    </a>
                    <div className="admn-nav-dropdown z150 dropdown-content list-unstyled u-shadow-v11 g-min-width-220 g-mt-8--lg--scrolling animated  ">
                      <ul className="p-0">
                        <li className="dropdown-item ">
                          <Link
                            to="/vision"
                            className="admn-nav-dropdown-item nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl g-py-1 dropbtn"
                          >
                            Vision & Mission
                          </Link>
                        </li>
                        <li className="dropdown-item ">
                          <Link
                            to="/management"
                            className="admn-nav-dropdown-item nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl g-py-1 dropbtn"
                          >
                            Management Team
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  {type !== '1' && (
                    <li
                      className="nav-item hs-has-mega-menu"
                      data-animation-in="fadeIn"
                      data-animation-out="fadeOut"
                      data-position="left"
                    >
                      <Link
                        id="mega-menu-label-1"
                        activeStyle={styles.activeLink}
                        to="/signIn"
                        className="ml-2 nav-link admn-nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl"
                      >
                        Sign In
                      </Link>
                    </li>
                  )}
                  <li
                    className="nav-item hs-has-mega-menu"
                    data-animation-in="fadeIn"
                    data-animation-out="fadeOut"
                    data-position="left"
                  >
                    <Link
                      id="mega-menu-label-1"
                      activeStyle={styles.activeLink}
                      to="/contact"
                      className="ml-2 nav-link admn-nav-link g-color-primary--hover g-font-size-15 g-font-size-17--xl"
                    >
                      Contact us
                    </Link>
                  </li>
                  {type !== '1' && (
                    <li className="d-none d-lg-block">
                      <a style={{ padding: '14px 18px' }} href="/contact" className="admn-cta-btn admn-cta-btn--outline admn-cta-btn--shadowless ml-2">Get Personalized Guidance</a>
                    </li>
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
    )
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/